export enum StepState {
	COMPLETED = 'completed',
	ACTIVE = 'active',
	PENDING = 'pending',
	ERROR = 'error'
}

export enum B2cFlowType {
	NEW_PLAN = 'new_plan',
	TRANSFER_CONFIRMED = 'transfer_confirmed'
}

export enum B2cLandingScenario {
	NO_PLAN = 'no-plan',
	PLAN_LOCATED = 'plan-located',
	PLAN_DETECTIVE = 'plan-detective'
}

export function detectLandingScenario(transfer: {
	metadata?: Record<string, any>;
	catalogId?: string | null;
}): B2cLandingScenario {
	const tipo = transfer.metadata?.tipo;
	if (tipo === B2cFlowType.NEW_PLAN) {
		return B2cLandingScenario.NO_PLAN;
	}
	if (transfer.catalogId) {
		return B2cLandingScenario.PLAN_LOCATED;
	}
	return B2cLandingScenario.PLAN_DETECTIVE;
}

// Backend sentinel used when a transfer has no real origin plan.
export const DGSFP_NO_CODE = 'SIN-CODIGO';

/**
 * Un código DGSFP de verdad, con la MISMA regla que comparsa (`utils/is-real-dgsfp.ts`): no
 * vacío y distinto del centinela, sin distinguir mayúsculas.
 *
 * Existe para que la plataforma no ofrezca firmar lo que el backend va a rechazar: sin plan de
 * origen real, el boletín saldría con el origen en blanco y la llamada devuelve «Transfer
 * request has no real origin plan».
 */
export const esDgsfpReal = (code?: string | null): boolean => {
	const valor = (code ?? '').trim();
	return valor.length > 0 && valor.toUpperCase() !== DGSFP_NO_CODE;
};

/**
 * Returns true when the transfer represents a new-plan opening (no origin plan),
 * as opposed to a real traspaso with an existing plan as source.
 *
 * Primary signal: metadata.tipo === 'new_plan' (set by the onboarding funnel).
 * Fallback: DGSFP_code is absent or the backend sentinel, with no origin in payload.
 */
export function isNewPlanTransfer(transfer: {
	metadata?: Record<string, any>;
	catalogId?: string | null;
	DGSFP_code?: string;
	originPayload?: Record<string, any>;
}): boolean {
	if (detectLandingScenario(transfer) === B2cLandingScenario.NO_PLAN) return true;
	return (
		(!transfer.DGSFP_code || transfer.DGSFP_code === DGSFP_NO_CODE) &&
		!transfer.originPayload?.dgsfpCode
	);
}
